<div class="header bg-gradient-primary py-7 py-lg-8">
  <div class="container">
    <div class="header-body text-center mb-5">
      <div class="row justify-content-center"></div>
    </div>
  </div>
</div>

<!-- Page content -->
<div class="container mt--8 pb-5">
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">

          <div class="text-center mb-4">
            <img
              src="assets/img/brand/logo-invertida.png"
              class="img-fluid login-logo"
              alt="Tem Cashback"
            />
          </div>
          <div class="text-center mb-4">
            Tem Cashback | Painel Administrativo
          </div>

          <!-- ===== FORMULÁRIO DE LOGIN ===== -->
          <div *ngIf="view === 'login'">
            <form [formGroup]="formLogin" (submit)="login()">
              <div class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                  </div>
                  <input
                    class="form-control"
                    placeholder="e-mail"
                    type="email"
                    formControlName="email"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                  </div>
                  <input
                    class="form-control"
                    placeholder="senha"
                    type="password"
                    formControlName="password"
                  />
                </div>
              </div>

              <div class="custom-control custom-control-alternative custom-checkbox mb-3">
                <input class="custom-control-input" id="customCheckLogin" type="checkbox" />
                <label class="custom-control-label" for="customCheckLogin">
                  <span class="text-muted">Lembra-me</span>
                </label>
              </div>

              <div class="text-center">
                <button type="submit" class="btn btn-primary my-2 w-100" [disabled]="loading">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  Entrar
                </button>
              </div>
            </form>

            <hr class="my-3" />

            <div class="text-center">
              <p class="text-muted small mb-2">É o seu primeiro acesso?</p>
              <button
                type="button"
                class="btn btn-default btn-sm"
                (click)="setView('firstAccess')"
              >
                <i class="ni ni-key-25 mr-1"></i> Primeiro Acesso
              </button>
            </div>
          </div>

          <!-- ===== FORMULÁRIO DE PRIMEIRO ACESSO ===== -->
          <div *ngIf="view === 'firstAccess'">

            <!-- Tela de sucesso -->
            <div *ngIf="firstAccessSuccess" class="text-center py-3">
              <div class="mb-3">
                <i class="ni ni-send" style="font-size: 3rem; color: #3D9A6B;"></i>
              </div>
              <h5 class="font-weight-bold" style="color: #3D9A6B;">E-mail enviado!</h5>
              <p class="text-muted small mt-2 mb-0">
                Enviamos um link de criação de senha para o e-mail informado.
              </p>
              <div class="alert alert-warning text-left mt-3 mb-0 py-2 px-3" style="font-size: 0.8rem;">
                <i class="ni ni-notification-70 mr-1"></i>
                <strong>Não recebeu?</strong> Verifique também a sua
                <strong>caixa de spam</strong> ou lixo eletrônico. O e-mail
                pode ser filtrado por alguns provedores.
              </div>
              <button type="button" class="btn btn-default btn-sm mt-3" (click)="setView('login')">
                <i class="ni ni-bold-left mr-1"></i> Voltar ao login
              </button>
            </div>

            <!-- Formulário de verificação -->
            <div *ngIf="!firstAccessSuccess">
              <div class="text-center mb-4">
                <h6 class="text-default font-weight-bold mb-1">Primeiro Acesso</h6>
                <small class="text-muted">
                  Informe os dados cadastrados para receber o link de criação de senha.
                </small>
              </div>

              <form [formGroup]="formFirstAccess" (submit)="sendFirstAccess()">
                <div class="form-group mb-3">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                    </div>
                    <input
                      class="form-control"
                      placeholder="e-mail cadastrado"
                      type="email"
                      formControlName="email"
                      [class.is-invalid]="formFirstAccess.get('email')?.invalid && formFirstAccess.get('email')?.touched"
                    />
                  </div>
                  <small
                    class="text-danger"
                    *ngIf="formFirstAccess.get('email')?.invalid && formFirstAccess.get('email')?.touched"
                  >
                    Informe um e-mail válido.
                  </small>
                </div>

                <div class="form-group mb-3">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="ni ni-badge"></i></span>
                    </div>
                    <input
                      class="form-control"
                      placeholder="CPF ou CNPJ cadastrado"
                      type="text"
                      formControlName="document"
                      [mask]="'000.000.000-00||00.000.000/0000-00'"
                      [class.is-invalid]="formFirstAccess.get('document')?.invalid && formFirstAccess.get('document')?.touched"
                    />
                  </div>
                  <small
                    class="text-danger"
                    *ngIf="formFirstAccess.get('document')?.invalid && formFirstAccess.get('document')?.touched"
                  >
                    Informe o CPF ou CNPJ.
                  </small>
                </div>

                <div class="text-center mt-3">
                  <button type="submit" class="btn btn-primary w-100" [disabled]="firstAccessLoading">
                    <span *ngIf="firstAccessLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                    <i *ngIf="!firstAccessLoading" class="ni ni-send mr-1"></i>
                    Enviar link de acesso
                  </button>
                </div>
              </form>

              <div class="text-center mt-3">
                <a href="javascript:void(0)" class="text-muted small" (click)="setView('login')">
                  <i class="ni ni-bold-left"></i> Voltar ao login
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Links abaixo do card -->
      <div class="row mt-3" *ngIf="view === 'login'">
        <div class="col-6">
          <a href="javascript:void(0)" class="text-light"><small>Perdeu a senha?</small></a>
        </div>
      </div>
    </div>
  </div>
</div>
